import IconCarbonCheckmarkOutline from '@/shared/icons/IconCarbonCheckmarkOutline'
import IconCarbonMisuseOutline from '@/shared/icons/IconCarbonMisuseOutline'
import { styled } from 'baseui'

const InteractionRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  padding: '0.25rem 0',
})

const InteractionLabel = styled('span', {
  fontSize: '0.875rem',
  color: '#2C2C2C',
})

const InteractionItem = ({ active, label }) => (
  <InteractionRow>
    {active
      ? (
        <IconCarbonCheckmarkOutline size={18} color='#0F9D58' />
        )
      : (
        <IconCarbonMisuseOutline size={18} color='#B0B0B0' />
        )}
    <InteractionLabel>{label}</InteractionLabel>
  </InteractionRow>
)

export default InteractionItem
